import { ChangeDetectorRef, Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedFunctionsService } from 'src/app/core/services/shared-functions.service';
import { HomeDashboardService } from '../../home-dashboards/home-dashboard.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { DATE_FORMAT } from 'src/app/app.constants';

@Component({
  selector: 'app-reviews-due',
  templateUrl: './reviews-due.component.html',
  styleUrls: ['./reviews-due.component.scss']
})
export class ReviewsDueComponent implements OnInit {

  @HostBinding('class') class = 'active-widget';
  @ViewChild('sort', {static: true}) sort: MatSort;
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;

  dataSource: any;
  displayedColumns = ['fullName', 'programmeType', 'lastReview','daysSinceReview'];
  showTable = false;
  loadingData = true;
  onlyMyLearnerStatus = true;
  hidePrivateLearnerStatus = true;
  rawData: any;

  dateFormat = DATE_FORMAT;

  constructor(
    private cdr: ChangeDetectorRef,
    private sharedFunctions: SharedFunctionsService,
    private homeDashboardService: HomeDashboardService,
  ) { }

  ngOnInit(): void {
  }

  initialApiCall(staffId: number){
    this.homeDashboardService.getReviewsDue(staffId).subscribe(
      result => {
        this.rawData = result.reportData;
        this.loadingData = false;
        this.dataSource = new MatTableDataSource(this.rawData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.filterData();
    });
  }

  toggleTable() {
    this.showTable = !this.showTable;
  }

  unCamelCase(str: string) {
    return this.sharedFunctions.unCamelCase(str);
  }

  isDate(value, column) {
    return this.sharedFunctions.isDateFromColumnName(value, column);
  }

  toggleOnlyMyLearnerStatus(value: MatSlideToggleChange) {
    this.onlyMyLearnerStatus = value.checked;
    this.filterData();
    this.cdr.detectChanges();
  }

  toggleHidePrivateLearnerStatus(value: MatSlideToggleChange) {
    this.hidePrivateLearnerStatus = value.checked;
    this.filterData();
  }


  filterData() {
    if(this.onlyMyLearnerStatus && this.hidePrivateLearnerStatus)
    {
      this.dataSource.data = this.rawData.filter(x => x.yourLearner == "Yes" && x.programmeTypeId !== 9);
    }
    else if(this.onlyMyLearnerStatus && !this.hidePrivateLearnerStatus) {
      this.dataSource.data = this.rawData.filter(x => x.yourLearner == "Yes");
    }
    else if(!this.onlyMyLearnerStatus && this.hidePrivateLearnerStatus) {
      this.dataSource.data = this.rawData.filter(x => x.programmeTypeId !== 9);
    }
    else {
      this.dataSource.data = this.rawData;
    }
    this.dataSource.paginator.firstPage();
    this.cdr.detectChanges();
  }

}
